import React, {useState, useEffect} from  'react';
import api from '../../services/api';
import Select from 'react-select';

export default function RolesSelect(props){

    const [roles, setRoles] = useState([]);
    const [defaultValue, setDefaultValue] = useState(null);
    const [options, setOptions] = useState([]);

    const onChange = (option) => {        
        props.onChange(option.value, option.object);
    };

    const getRoles = () => {
        api.get('/clients/roles')
        .then(response => {     
            setRoles(response.data.data);                   
        });         
    }

    const getOptions = () => {
        let options = [
            {value: null, label: (props.label ? props.label : '-- Selecione --')} 
        ];        
        roles.map((item, index) => {
            let option = {
                value: item.id,
                label: item.attributes.name,
                object: item
            };
            options.push(option);
        });
        setOptions(options);         
    };   

    useEffect(() => {        
        getRoles();
    }, []);

    useEffect(() => {
        getOptions();
    }, [roles]);

    useEffect(() => {          
        options.map((option, index) => {            
            if(option.value == props.defaultValue){                  
                setDefaultValue(option);                
            }            
        });
    }, [options]);

    return (
        <>
            {(options && defaultValue) && <Select options={options} defaultValue={defaultValue} onChange={onChange} />}
        </>
    );

}